<template>
  <div v-loading="loading" class="org-tree-container">
    <div style="display: flex;justify-content: space-between;">
      <div>
        <el-button @click="handleAddOrgDialog" :icon="$ElIcons.Plus" type="mini"/>
        <el-button @click="handleDelete" :icon="$ElIcons.Delete" type="mini"/>
        <el-button @click="handleFold" :icon="defaultExpandAll ? $ElIcons.Expand : $ElIcons.Fold" type="mini"/>
      </div>
      <el-button @click="handleShowProjectDialog" :icon="$ElIcons.Switch" type="mini"/>
      <dy-dialog v-model="showProjectDialog" title="切换项目" :width="500" confirmTitle="确定" @onConfirm="handleDialogConfirm">
        <div>
          <el-input v-model="queryForm.orgSearch" placeholder="请输入搜索条件" @input="handleOrgTreeFilter"/>
          <el-tree
              ref="orgTreeRef"
              :data="orgTree"
              :props="treeProps"
              show-checkbox
              check-strictly
              node-key="id"
              default-expand-all
              :filter-node-method="orgFilterNode"
              @check-change="handleOrgTreeCheckChange"
          />
        </div>
      </dy-dialog>
    </div>
    <el-input v-model="searchName" placeholder="请输入搜索条件" style="margin: 10px 0;" :onkeydown="handleKeyDown">
      <template v-slot:suffix>
        <el-button @click="handleFilter()" type="text" :icon="$ElIcons.Search"/>
      </template>
    </el-input>

    <el-table ref="tableRef" :data="filterTableData" row-key="id" :default-expand-all="defaultExpandAll" border
              highlight-current-row v-loading="tableLoading"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @current-change="handleTableSelect" lazy
              :load="lazyLoad">
      <el-table-column label="名称" min-width="80" prop="name" show-overflow-tooltip column-key="name">
        <template v-slot="{row}">
          <span v-if="!row.assetType">{{ row.name }}</span>
          <a v-else class="tree_label" @click.stop="handleEdit(row)">{{ row.name }}</a>
        </template>
      </el-table-column>
      <el-table-column label="层级" min-width="30" prop="attr.level" show-overflow-tooltip>
        <template v-slot="{row, $index}">
          {{ $index === 0 ? '项目' : enums.levelType[row.assetType] }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getDictionaryList } from "@/api/dictionary";
import { mapGetters } from 'vuex'
import { deepClone } from '@/util'
export default {
  name: "DyOrgTree",
  props: {
    levelApi: {
      type: String,
      default: undefined
    },
    orgTreeApi: {
      type: Object,
      default: undefined
    },
  },
  data() {
    return {
      tableLoading: false,
      showProjectDialog: false,
      queryForm: {
        orgSearch: undefined,
        projectCode: undefined,
        selectedTableRowId: undefined
      },
      enums: {
        levelType: {}
      },
      tableData: [],
      orgTree: [],
      searchName: undefined,
      filterTableData: [],
      loading: false,
      defaultExpandAll: true,
      selectNode: undefined,
      treeProps: {
        children: 'children',
        label: 'name',
      }
    };
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      let assetTypeRes = await getDictionaryList({dicCode: this.levelApi});
      assetTypeRes.data.data.forEach(item => {
        this.enums.levelType[item.value] = item.label
      })
      let res = await orgTreeApi()
      let projectCode = this.formatterOrgTree(res.data.data)
      if (projectCode) {
        this.queryForm.projectCode = projectCode
        this.orgTree = res.data.data || [];
        // this.$refs.orgTreeRef.setCheckedKeys([projectCode])
        this.getTableList()
      }
    },
    handleTableSelect(row) {
      if (row && row.assetType) {
        this.queryForm.selectedTableRowId = row.id
      } else {
        this.queryForm.selectedTableRowId = undefined
      }
      this.$emit('orgChange', this.queryForm)
    },
    handleOrgTreeCheckChange(data, checked) {
      // 单选控制
      if (checked) {
        this.$refs.orgTreeRef.setCheckedKeys([data.id])
        // this.queryForm.projectCode = data.id
        // this.getTableList()
      }
    },
    handleShowProjectDialog(){
      this.showProjectDialog = true
      this.$nextTick(()=>{
        this.$refs.orgTreeRef.setCheckedKeys([this.queryForm.projectCode])
      })
    },
    handleDialogConfirm(){
      const orgCode = this.$refs.orgTreeRef.getCheckedKeys()[0]
      this.queryForm.projectCode = orgCode
      this.showProjectDialog = false
      this.getTableList()
    },
    handleOrgTreeFilter() {
      if (this.interval) {
        clearTimeout(this.interval)
      }
      this.interval = setTimeout(() => {
        console.log('>>>>>>>>>>>>>...')
        this.$refs.orgTreeRef.filter(this.queryForm.orgSearch);
      }, 500)
    },
    handleDelete() {
      if (!this.queryForm.selectedTableRowId) return
      this.$confirm(
          '此操作将永久删除该架构, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        // delAsset(this.queryForm.selectedTableRowId)
        //     .then(() => {
        //       this.$notify.success('删除成功')
        //     })
      })
    },
    handleEdit(row) {
      if (!this.queryForm.projectCode) return
      //this.$refs.addOrgRef.open(this.queryForm.projectCode, row.id)
    },
    handleAddOrgDialog() {
      if (!this.queryForm.projectCode) return
      //this.$refs.addOrgRef.open(this.queryForm.projectCode)
    },
    handleKeyDown(e) {
      if (e.code === "Enter") {
        this.handleFilter()
      }
    },
    handleFilter() {
      let res = deepClone(this.tableData)
      if (this.searchName) {
        this.searchFilter(res)
      }
      this.filterTableData = res
    },
    handleFold() {
      this.defaultExpandAll = !this.defaultExpandAll
      // table折叠
      let ref = this.$refs.tableRef
      this.folder(ref, this.filterTableData, this.defaultExpandAll)
      // tree折叠
      // for(let j=0; j<this.$refs.tableRef.store._getAllNodes().length; j++){
      //   this.$refs.tableRef.store._getAllNodes()[j].expanded= this.defaultExpandAll
      // }
    },
    getTableList() {
      this.tableLoading = true
      this.queryForm.selectedTableRowId = undefined
      this.$emit('orgChange', this.queryForm)
      orgTreeApi({
        projectCode: this.queryForm.projectCode,
        tenantCode: localStorage.getItem("xt-code"),
      }).then(res => {
        this.tableData = res.data.data
        this.filterTableData = res.data.data
        setTimeout(() => {
          this.tableLoading = false
        }, 200)
      })
    },
    searchFilter(arr) {
      let filter = arr.filter(item => {
        if (item.children) {
          this.searchFilter(item.children)
        }
        return item.name.includes(this.searchName) || (item.children && item.children.length)
      })
      arr.splice(0, arr.length, ...filter)
    },
    // 格式化并返回第一个项目
    formatterOrgTree(arr) {
      let firstProjectCode = undefined
      arr.forEach(item => {
        if (item.attr.orgType === 'project') {
          item.disabled = false
          firstProjectCode = firstProjectCode || item.id
        } else {
          item.disabled = true
        }
        if (item.children && item.children.length) {
          let resCode = this.formatterOrgTree(item.children)
          firstProjectCode = firstProjectCode || resCode
        }
      })
      return firstProjectCode
    },
    folder(ref, data, isFold) {
      data.forEach(item => {
        ref.toggleRowExpansion(item, isFold)
        if (data.children && data.children.length) {
          this.folder(ref, item.children, isFold)
        }
      })
    },
    orgFilterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    lazyLoad(row, treeNode, resolve) {
      orgTreeApi({
        projectCode: row.id,
        tenantCode: localStorage.getItem("xt-code"),
      }).then(res => {
        if (res.data.data && res.data.data.length && res.data.data[0].children) {
          let children = res.data.data[0].children
          this.formatterAssetTree(children, row.id)
          row.children = children
          resolve(children)
        } else {
          resolve([])
        }
      })
    },
    formatterAssetTree(arr, projectCode) {
      arr.forEach(item => {
        item.projectCode = projectCode
        if (item.children && item.children.length) {
          this.formatterAssetTree(item.children, projectCode)
        }
      })
    },
    /**
     * 懒加载刷新node方式
     * @param arr
     * @param projectCode
     * @returns {{children}|*}
     */
    loadNode(projectCode) {
      let filterTableData = this.findProjectNodeData(this.filterTableData, projectCode)
      console.log(this.selectNode)
      let ref = this.$refs.tableRef
      ref.store.states.treeData.value[projectCode].loaded = false
      ref.store.loadOrToggle(filterTableData);
    },
    findProjectNodeData(arr, projectCode) {
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i]
        if (item.children && item.children.length) {
          let res = this.findProjectNodeData(item.children, projectCode)
          if (res) return res
        }
        if (item.id === projectCode) return item
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.org-tree-container {
  box-sizing: border-box;
  background: white;
  height: 100%;
  padding: 10px;
  margin-right: 10px;
  width: 300px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .tree_label {
    color: #597EF7 !important;
    text-decoration: underline !important;
    font-weight: bold;
    cursor: pointer;
  }
}

::v-deep .is-disabled {
  display: none !important;
}
</style>
